import type { ManualDetail } from "@/api/db/manuals";
import { ConfirmationDialog } from "@/components/ui/confirmation-dialog";
import { useManualRevoke } from "@/hooks/use-manuals";
import { ManualLabels } from "@/lib/labels/manuals";

const TRIGGER_CLASSNAME =
	"inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-input bg-background px-3 text-xs font-medium shadow-control transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 md:h-8";

export function RevokeAction({ manual }: { manual: ManualDetail }) {
	const revoke = useManualRevoke();

	if (manual.status !== "delivered") {
		return null;
	}

	return (
		<ConfirmationDialog
			slot="revoke-trigger"
			tone="destructive"
			title={ManualLabels.revokeConfirm}
			pendingLabel={ManualLabels.revoking}
			isPending={revoke.isPending}
			onConfirm={() => revoke.mutate({ id: manual.id })}
			className={TRIGGER_CLASSNAME}
		>
			{ManualLabels.revokeButton}
		</ConfirmationDialog>
	);
}
